import { memo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { LockedIcon } from "../../../../components/MuiIcons";
import { useCompanyAuth } from "../../hooks/useCompanyAuth";
import { AUTH_COMPANY_ID, TCompany } from "../../models";
import { CompanyCard, CompanyID, CompanyName } from "./styles";
import { useAuth } from "../../../../auth/useAuth";

export const CompanyAuthButton = memo(
  ({ item, handleClose }: { item: TCompany; handleClose?: () => void }) => {
    const { id, isActive, name } = item;
    const { isSuperAdmin } = useAuth();
    const authorizedCompanyId = localStorage.getItem(AUTH_COMPANY_ID);
    const [result, _loading, _error, _request, _isAuthorized, authHandler] =
      useCompanyAuth(id);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
      if (result) {
        if (pathname === "/selectcompanies") {
          if (isSuperAdmin) {
            navigate("/companies?list");
          } else {
            navigate("/verification-requests/page/1");
          }
        }
        handleClose?.();
      }
    }, [result, navigate, isSuperAdmin, pathname, handleClose]);

    return (
      <CompanyCard
        disabled={!isActive}
        onClick={() => authHandler(item)}
        selected={authorizedCompanyId === id}
      >
        <CompanyName component="span">{name}</CompanyName>
        <CompanyID component="span">{id}</CompanyID>
        {!isActive && (
          <LockedIcon
            sx={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translate(0, -50%)",
            }}
          />
        )}
      </CompanyCard>
    );
  }
);
